import { StyleSheet } from 'react-native';

export const createStyles = (colors: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    scrollContent: {
      padding: 20,
      gap: 20,
    },
    logoContainer: {
      alignItems: 'center',
      gap: 8,
    },
    logoCircle: {
      width: 80,
      height: 80,
      borderRadius: 40,
      backgroundColor: colors.card,
      borderWidth: 2,
      borderColor: colors.border,
      borderStyle: 'dashed',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
    },
    logoImage: {
      width: 80,
      height: 80,
      borderRadius: 40,
    },
    logoHint: {
      fontSize: 12,
      color: colors.textTertiary,
    },
    section: {
      gap: 8,
    },
    label: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.text,
    },
    sublabel: {
      fontSize: 13,
      color: colors.textTertiary,
    },
    input: {
      backgroundColor: colors.card,
      borderRadius: 10,
      padding: 14,
      fontSize: 16,
      color: colors.text,
      borderWidth: 1,
      borderColor: colors.border,
    },
    textArea: {
      minHeight: 80,
      textAlignVertical: 'top',
    },
    presetGrid: {
      gap: 10,
    },
    presetCard: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.card,
      borderRadius: 10,
      padding: 14,
      borderWidth: 2,
    },
    presetCardSelected: {
      borderColor: colors.primary,
    },
    presetCardUnselected: {
      borderColor: colors.border,
    },
    presetInfo: {
      flex: 1,
      marginLeft: 12,
    },
    presetTitle: {
      fontSize: 15,
      fontWeight: '600',
      color: colors.text,
    },
    presetDesc: {
      fontSize: 12,
      color: colors.textTertiary,
      marginTop: 2,
    },
    checkBadge: {
      width: 24,
      height: 24,
      borderRadius: 12,
      backgroundColor: colors.primary,
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonRow: {
      flexDirection: 'row',
      gap: 12,
      marginTop: 10,
    },
    primaryButton: {
      flex: 1,
      backgroundColor: colors.primary,
      borderRadius: 10,
      padding: 16,
      alignItems: 'center',
    },
    primaryButtonText: {
      color: colors.primaryText,
      fontSize: 16,
      fontWeight: '600',
    },
    secondaryButton: {
      flex: 1,
      backgroundColor: colors.card,
      borderRadius: 10,
      padding: 16,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: colors.border,
    },
    secondaryButtonText: {
      color: colors.text,
      fontSize: 16,
      fontWeight: '600',
    },
    disabledButton: {
      opacity: 0.6,
    },
    visibilityRow: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 14,
      borderRadius: 10,
      borderWidth: 1,
      gap: 12,
    },
    visibilityInfo: {
      flex: 1,
      gap: 2,
    },
    visibilityTitle: {
      fontSize: 15,
      fontWeight: '600',
    },
    visibilityDesc: {
      fontSize: 12,
    },
  });
